// src/api/signalRClient.ts
import * as signalR from "@microsoft/signalr";

let connection: signalR.HubConnection | null = null;

export function createSignalRConnection() {
  // Close any old connection before creating a new one
  if (connection) {
    try {
      connection.stop();
    } catch {}
    connection = null;
  }

  const baseRaw =
    process.env.REACT_APP_SIGNALR_BASE || "https://localhost:7243"; 

  // Remove trailing /api (SignalR root MUST be host)
  const base = baseRaw.replace(/\/api\/?$/, "");

  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${base}/hubs/chat`, {
      accessTokenFactory: () => localStorage.getItem("token") || "",
      transport: signalR.HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  return connection;
}

export function getConnection() {
  return connection;
}

export async function disconnectSignalR() {
  if (connection) {
    try {
      await connection.stop();
    } catch {}
    connection = null;
  }
} 
